<template>
  <div>
    <v-select
      v-model="selectedFilterId"
      :items="componentOptions"
      item-text="label"
      item-value="id"
      clearable
      :label="$t('common.FilterBy')"
    />
    <v-select
      v-if="selectedFilterId"
      v-model="filterValues"
      :items="filterOptions"
      item-text="text"
      return-object
      class="ml-4"
      multiple
      clearable
      :label="$t('common.Values')"
    />
  </div>
</template>

<script>
/*
LogFilter

Props: logs: Array[Log]
Emits: filtered: Array[log]
       filterMap: Array[Boolean] || null

Returns an array of booleans representing which logs obey the Selected filters.
If no filters are selected, returns null
*/


import statistics from '@/statistics'
import { LogMapper } from '@/statistics/mappers/base'
import { Component } from '@/models/Specialty'

export default {
  props: {
    logs: {type: Array, default: ()=>([])}
  },
  data: () => ({
    selectedFilterId: null,
    filterValues: [],
  }),
  computed: {
    componentOptions() {
      let components = Component.query()
        .where('statistics', true)
        .withAllRecursive()
        .get()
      return components
    },
    mapper() {
      return statistics[this.$store.getters.specialty] || LogMapper
    },
    filterOptions() {
      return this.mapper.getOptions(this.selectedFilter, this.logs)
    },
    selectedFilter() {
      return this.componentOptions.find((cf) => cf.id === this.selectedFilterId)
    },
    componentChecker(){
      return this.getChecker(this.selectedFilter)
    },
    filterMap() {
      if (
        this.selectedFilterId &&
        this.filterValues &&
        this.filterValues.length
      ) {
        return this.logs.map((log) =>
          this.filterValues.some(
            (fv) => (this.componentChecker(log, this.selectedFilterId, fv))
          )
        )
      } else {
        return null
      }
    },
    filteredLogs(){
      if(this.filterMap === null) return this.logs

      const returnedLogs = []
      for (let i = 0; i < this.filterMap.length; i++) {
        if(this.filterMap[i]){
          returnedLogs.push(this.logs[i])
        }
      }
      return returnedLogs
    },
  },
  methods: {
    emitChanges(){
      this.$emit('filtered', this.filteredLogs)
      this.$emit('filterMap', this.filterMap)
    },
    getChecker(component) {
      const id = (component || {}).id
      if (this.mapper.components[id]) {
        return this.mapper.components[id].checker
      }
      return LogMapper.checker
    },
  },
  watch: {
    selectedFilterId(){
      this.filterValues = []
      this.emitChanges()
    },
    filterValues(){
      this.emitChanges()
    },
  },
  created() {
    this.emitChanges()
  }
}
</script>
